<template>
  <div id="app">
    <v-app>
      <div>
        <v-app-bar v-bind:color="this.appBarColor" dark>
          <v-toolbar-title
            class="font-weight-bold"
            v-bind:class="this.textColor"
            >{{ appTitle }}</v-toolbar-title
          >
        </v-app-bar>
      </div>
      <v-content id="content">
        <router-view />
      </v-content>
      <v-footer v-bind:color="this.appBarColor">
        <!--全体を右寄せにする-->
        <div class="flex-grow-1"></div>

        <v-container class="mr-4" v-bind:class="this.textColor">
          <v-row justify="end">
            <div>version : {{ this.GitHash }}</div>
          </v-row>
          <v-row justify="end">
            <div>&copy; 2021 - {{ new Date().getFullYear() }} kkkkan</div>
          </v-row>
          <v-row justify="end">
            <div>kan4649kan@gmail.com</div>
          </v-row>
        </v-container>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import GitHash from '@/assets/hash.json'

export default {
  name: 'App',
  data() {
    return {
      GitHash: GitHash,
      appTitle: String,
      appBarColor: String,
      textColor: String,
    }
  },
  methods: {
    // タイトルを設定する
    // 表示しているページによって変える
    createTitleDesc: function (routeInstance) {
      if (routeInstance.meta.appTitle) {
        var setTitle = routeInstance.meta.appTitle
        this.appTitle = setTitle
      } else {
        this.appTitle = 'title is not set'
      }

      if (routeInstance.meta.appBarColor) {
        this.appBarColor = routeInstance.meta.appBarColor
      } else {
        this.appBarColor = 'red lighten-3'
      }

      if (routeInstance.meta.textColorClass) {
        this.textColor = routeInstance.meta.textColorClass
      } else {
        this.textColor = 'black'
      }
    },
  },
  mounted: function () {
    var routeInstance = this.$route
    this.createTitleDesc(routeInstance)
  },
  watch: {
    $route(routeInstance) {
      this.createTitleDesc(routeInstance)
    },
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#content {
  margin-top: 20px;
}
</style>
